import { forwardRef, useEffect, useRef } from 'react';
import MarkdownBase from './MarkdownBase';
import { Stack } from '@mui/material';
import { MarkdownReadOnlyProps } from './types';
import {
  imagePlugin,
  linkDialogPlugin,
  markdownShortcutPlugin,
  MDXEditorMethods,
  tablePlugin,
} from '@mdxeditor/editor';

const MarkdownReadOnly = forwardRef<MDXEditorMethods, MarkdownReadOnlyProps>(
  (props, ref) => {
    const editorRef = useRef<HTMLDivElement>(null);

    const { markdown = '', openLinksInNewTab, ...rest } = props;

    useEffect(() => {
      if (!openLinksInNewTab) return;

      const links = editorRef.current?.querySelectorAll('a');

      links?.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [markdown]);

    return (
      <Stack ref={editorRef}>
        <MarkdownBase
          ref={ref}
          readOnly
          markdown={markdown}
          {...rest}
          plugins={[
            linkDialogPlugin(),
            imagePlugin(),
            tablePlugin(),
            markdownShortcutPlugin(),
          ]}
        />
      </Stack>
    );
  },
);

MarkdownReadOnly.displayName = 'MarkdownReadOnly';
export default MarkdownReadOnly;
